module.exports = __webpack_public_path__ + "img/logo.db8a1ec5.gif";